import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-6 bg-[#051611] text-white"
      data-testid="not-found-page"
    >
      <div className="max-w-md w-full text-center space-y-5">
        <div className="w-16 h-16 mx-auto rounded-full bg-[#0E2924] border border-[#1B4238] flex items-center justify-center">
          <Compass className="w-8 h-8 text-[#22E07A]" strokeWidth={2.4} />
        </div>
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#22E07A]">
          Off the map
        </p>
        <h1
          className="text-3xl sm:text-4xl font-extrabold leading-tight"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          This page doesn&rsquo;t exist.
        </h1>
        <p className="text-sm text-[#C7DAD3] leading-relaxed">
          The link you followed might be broken, or the page has moved. Let&rsquo;s get you back to your battles.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-[#22E07A] hover:bg-[#17C06A] text-[#05160D] font-extrabold uppercase tracking-wider text-sm transition-transform hover:scale-105 active:scale-95"
          style={{ fontFamily: "Outfit, sans-serif" }}
          data-testid="not-found-home-link"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
